import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Invoice, DisablePendingInvoicePayload } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['payload', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'DISABLE_PENDING_INVOICE_',
  }
);

export interface DisablePendingInvoiceState {
  data: Invoice[];
  loading: boolean;
  errorMessage: string | null;
}

export interface DisablePendingInvoiceRequestAction {
  payload: DisablePendingInvoicePayload;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: DisablePendingInvoiceState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: DisablePendingInvoiceState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: DisablePendingInvoiceState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: DisablePendingInvoiceState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: DisablePendingInvoiceState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const disablePendingInvoice = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const DisablePendingInvoiceTypes = Types;
export const DisablePendingInvoiceActions = Creators;
